import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { BaseAPIService } from "../baseapi/baseapiservice";
import { StructureControlRequest } from "../../models/requests/structurecontrolrequest";
import { StructureControlResponse } from "../../models/structurecontrolresponse";
import { ProvisionItem } from "../../models/provisionitem";
import { ProvisionContent, ProvisionContentRow } from '../../models/provisioncontent';
import { HttpClient } from '@angular/common/http';
import { ProvisionService } from '../provision/provision.service';

@Injectable()
export class StructureService extends BaseAPIService {

    constructor(private http: HttpClient, 
                private provisionService: ProvisionService) {
        // call the BaseAPIService constructor
        super();
    }
    // locked FPCs
    private factoryLockedfpcs = new Array<ProvisionItem>();

    validateProvision(): Observable<StructureControlResponse> {
        let request = new StructureControlRequest();
        request.PDVersion = this.provisionService.getProvision().PDVersion;
        request.CSpec = this.provisionService.getCurrentProvision();
        request.IgnoreCO = true; // TODO: remove? not possible to act on CO suggestions anyway
        request.OnlyIndicateStoppingStructureErrors = false; // get error message for unhandled errors
        request.StartObject = this.provisionService.getStartObject(); // Sending EP:1 parameter as default to OAS
        request.LockedFPCs = this.calculateLockedFPCs();
        request.TimeValidity = this.provisionService.getValidityFlag(); // Sending false as default to OAS (time validity flag)

        return this.http.post<StructureControlResponse>(environment.baseurl + 'Structure/PerformStructureControlConfigurator', request).pipe(
            catchError(this.handleError)
        );
    }

    private calculateLockedFPCs(): Array<ProvisionItem> {
        let lockedFPCs = new Array<ProvisionItem>();
        let factoryLockedFPCs = this.factoryLockedfpcs;
        let initialCSpec = this.provisionService.getCurrentProvision();
        let lockedChanges = this.provisionService.getProvisionChanges().filter(x => !x.IsInCSpec && x.Type === "FPC");
        
        lockedFPCs = initialCSpec.filter(x => factoryLockedFPCs.some(y => x.Family == y.Family));
        lockedChanges.forEach(x => lockedFPCs.push(new ProvisionItem(x.Type, x.Family, x.FamilyDescription, x.ToExecution, null, false))); 

        return lockedFPCs;
    }

    getLockedFPCs(): Observable<Array<ProvisionItem>> {
        return this.http.get<Array<ProvisionItem>>(environment.rebuildUrl +'/lockedfpcs').pipe(
            map(response => this.factoryLockedfpcs = response),
            catchError(this.handleError)
        );
    }

    getProvisionsForUser(user: string) {
        return this.http.post<Array<{ ProvisionOwner: string, ProvisionName: string }>>(`${environment.conversionWebApiUrl}/provisions/list`, {
            ProvisionType: user,
            Language: 'en'
        }).pipe(
            catchError(this.returnError)
        );
    }

    getProvision(provisionId: string, provisionUserName: string): Observable<ProvisionContent> {
        return this.http.post<ProvisionContent>(`${environment.conversionWebApiUrl}/provisions/content`, {
            Owner: provisionUserName,
            Instance: provisionId,
            IncludeDetails: true
        }).pipe(
            catchError(this.returnError)
        );
    }

    saveProvision(provisionId: string, provisionUserName: string, entityTag: string, rows: ProvisionContentRow[], partPeriod?: string) {
        return this.http.put(`${environment.conversionWebApiUrl}/provisions/content`, {
            Owner: provisionUserName,
            Instance: provisionId,
            EntityTag: entityTag,
            Rows: rows,
            ...(partPeriod !== undefined ? { PartPeriod: partPeriod } : {})
        }).pipe(
            catchError(this.returnError)
        );
    }
}
